import { generatePath } from 'react-router-dom'
import { ActivityStatus, ActivityType } from '@common/interfaces/activity'
import queryString from 'query-string'
import { ROUTES } from '../constants/routes'

/** Minimal activity fields needed to build wires / checks / mid-day deep links */
export type ICollectionsActivityLinkInput = {
  id: string
  type: ActivityType
  status: string
  recordDate: string
}

const COLLECTIONS_ACTIVITY_TYPES: string[] = [
  ActivityType.Check,
  ActivityType.Wire,
  ActivityType.MidDayWire,
]
const COMPLETED_ACTIVITY_STATUSES: string[] = [ActivityStatus.Complete, ActivityStatus.Archived]

/**
 * Deep link for collections workflow pages (matches ActivityQueue row links).
 * Returns undefined if the activity is not a collections type or in-progress data is incomplete.
 */
export function getCollectionsActivityDeepLink(
  activity: ICollectionsActivityLinkInput,
): string | undefined {
  if (!COLLECTIONS_ACTIVITY_TYPES.includes(activity.type)) {
    return undefined
  }

  const isCheck = activity.type === ActivityType.Check
  const isWire = activity.type === ActivityType.Wire

  if (COMPLETED_ACTIVITY_STATUSES.includes(activity.status)) {
    return `${generatePath(ROUTES.COLLECTIONS_DASHBOARD)}?${queryString.stringify({
      type: isCheck ? 'check' : 'wire',
      activityId: activity.id,
    })}`
  }

  if (!activity.recordDate) {
    return undefined
  }

  const basePath = isCheck
    ? ROUTES.COLLECTIONS_CHECKS
    : isWire
      ? ROUTES.COLLECTIONS_WIRES
      : ROUTES.COLLECTIONS_MID_DAY_WIRES

  return `${generatePath(basePath)}?${queryString.stringify({
    activityId: activity.id,
    recordDate: activity.recordDate,
  })}`
}
